import { render, staticRenderFns } from "./SOVallDetailed.vue?vue&type=template&id=0b644151&scoped=true"
import script from "./SOVallDetailed.vue?vue&type=script&lang=js"
export * from "./SOVallDetailed.vue?vue&type=script&lang=js"
import style0 from "./SOVallDetailed.vue?vue&type=style&index=0&id=0b644151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b644151",
  null
  
)

export default component.exports